export var IMAGE_UPLOAD_ERROR = -2;
export var IMAGE_UPLOAD_PENDING = 2;
export var IMAGE_UPLOAD_DONE = 5;
